var wt = $(window).scrollTop(),
	wh = $(window).height(),
	wb = wt + wh;

$(window).ready(function() {
	basicDelay = 1

	$('.la-svg-home').addClass('animate');
	$('.to-move').addClass('animate');
	$('.slide-title').addClass('animate');
	$('.left-image').addClass('animate');
	$('.logo-blog').addClass('animate');
	$('.ad-life-logo').addClass('animate');
	$('.title').addClass('animate');
	$('.page-title').addClass('animate');
	$('.notification-bubble').addClass('animate');
	$('.controller-block').addClass('animate');
	$('.lawyer-name').addClass('animate');
	$('.slider-landing').addClass('animate');
	$('.focus-landing').addClass('animate');
	$('.focus-guillemet').addClass('animate');
	$('.js-fade-in').addClass('animate');

	TweenMax.staggerFrom($(".block-to-animate"), 1.3, {
		delay: basicDelay,
		y: -50,
		opacity: "0",
		ease:Power3.easeOut,
	}, 0.3);

	$(function(){    
	    if ($('.js-to-show').length) {
	        $('.js-to-show').showOnScroll();
	    }
	});

	$(window).on('scroll', function(){
		wt = $(window).scrollTop();
		wb = wt + wh;
	});
});

(function ( $ ) {
    $.fn.showOnScroll = function() {
        var items = [];

        $(this).each(function() {
            var $that = $(this),
                offset = $that.height()*$that.data('offset') || 50,
                offset = $that.data('pixel-offset') || offset,
                top = $that.offset().top + offset,
                toShow = wb > top ? true : false;

            if (toShow) {
                $that.addClass('shown');
            } else {
                items.push({
                    trigger: $that,
                    top : top
                });
            };
        });

        return $(window).scroll(function(e) {
            e.preventDefault();
            items.map(function(elem, i){
                if (elem.top <= wb) {
                    elem.trigger.addClass('shown');
                };
            });
        });
    };
}( jQuery ));


